import { render, staticRenderFns } from "./WorkDetail4.vue?vue&type=template&id=5b2a0316&scoped=true&"
import script from "./WorkDetail4.vue?vue&type=script&lang=js&"
export * from "./WorkDetail4.vue?vue&type=script&lang=js&"
import style0 from "./WorkDetail4.vue?vue&type=style&index=0&id=5b2a0316&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2a0316",
  null
  
)

export default component.exports